import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Title } from '@siftscience/focus-components/text'
import { useTemplateContext } from '../context/template-context'
import RootTemplate from './root-template'
import Search from './search'
import AddProcessorField from './add-processor-field'
import { useCurrentUser } from '../../../contexts/CurrentUserContext'
import { NONE_MERCHANT, useMerchantContext } from '../context/merchant-context'
import {
  NONE_PROCESSOR,
  useProcessorContext
} from '../context/processor-context'

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '320px',
    height: 'calc(100vh - 84px - 64px - 36px)', // 84 for template tooling header, 64 for global header and 34 is for footer
    boxShadow: '0px 1px 4px 0px #24242429'
  },
  itemsWrapper: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%'
  }
}))

const Navigation = (): React.ReactElement => {
  const { rootTemplates, isTemplatesLoading } = useTemplateContext()
  const { selectedMerchant } = useMerchantContext()
  const { selectedProcessor } = useProcessorContext()
  const { currentUser } = useCurrentUser()
  const classes = useStyles()
  const isNoMerchantSelected =
    !selectedMerchant || selectedMerchant.id === NONE_MERCHANT.id
  const isProcessorSelected =
    selectedProcessor && selectedProcessor.id !== NONE_PROCESSOR.id
  const isAddProcessorAllowed =
    currentUser.hasAccess(['Super Administrator']) &&
    isNoMerchantSelected &&
    isProcessorSelected

  return (
    <div className={classes.wrapper}>
      <Search />
      {isTemplatesLoading ? (
        <Title>Loading...</Title>
      ) : rootTemplates && rootTemplates.length ? (
        <div className={classes.itemsWrapper}>
          {rootTemplates.map(template => (
            <RootTemplate key={template.templateId} template={template} />
          ))}
        </div>
      ) : (
        <Title>No Templates to display</Title>
      )}
      {isAddProcessorAllowed && <AddProcessorField />}
    </div>
  )
}

export default Navigation
